/**
 * @packageDocumentation
 * @module HackerAPI.Claim.Filters
 */
import { __extends } from "tslib";
import Base from "../../base/base";
/**
 * A container for a given set of filters to apply to claim fetching for a pipeline
 * @class
 * @extends { HackerAPI.Base }
 */
var Filters = /** @class */ (function (_super) {
    __extends(Filters, _super);
    /**
     * Creates a new instance of claim filters
     * @constructor
     * @param filters
     */
    function Filters(_a) {
        var _b = _a === void 0 ? {} : _a, page_size = _b.page_size, pageSize = _b.pageSize, page = _b.page, user_id = _b.user_id, userId = _b.userId, stage = _b.stage, orderBy = _b.orderBy, order_by = _b.order_by;
        var _this = _super.call(this) || this;
        /**
         * The number of claims to return
         */
        _this.pageSize = page_size || pageSize || undefined;
        /**
         * What page of claims to return (1-based indexing)
         */
        _this.page = page || 1;
        /**
         * Filter to only show the claim for a certain user ("me" for the authenticators claim)
         */
        _this.userId = user_id || userId || undefined;
        /**
         * Only return claims in the given stage
         */
        _this.stage = stage || undefined;
        /**
         * Order by some fields
         */
        _this.orderBy = order_by || orderBy || undefined;
        return _this;
    }
    return Filters;
}(Base));
export default Filters;
//# sourceMappingURL=filters.js.map